import * as React from 'react';
import StreamView from './View';
import { IShowroomProps } from 'components/Showroom';
import { user } from 'utils/auth/user';

interface IStreamProps {
  userType?: IShowroomProps['userType'];
  className?: string;
  expanded?: boolean;
}

const defaultClassName = 'ex3d-fullscreen-stream ext3d-brand-layout flex h-screen flex-col';
const Stream: React.FC<IStreamProps> = ({ userType = user.type, className = defaultClassName, expanded }) => {
  return (
    <StreamView
      userType={userType}
      className={className}
      expanded={expanded}
      isSessionHost={false}
      bandwidthOptimisation={{ enabled: true }}
    />
  );
};

export default Stream;
